import React, { useEffect, useState } from "react";
import { AppRoutes } from "../../router";
import Header from "../components/header";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { Loader } from "../components/Loader";
import { Routes, Route } from "react-router-dom";
import ComingSoon from "../pages/ComingSoon";
import { useDispatch, useSelector } from "react-redux";
import { apiRoutes } from "../../apis/routes";
import { getRequest } from "../../apis/methods";
import { settingHandler } from "../../store/slices/settingsSlice";
import TermsCondition from "../pages/TermsCondition";
import Policy from "../pages/PrivacyPolicy";
export const AppLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  // const isProd=true;
  const { loading } = useAuth();
const [isProd, setIsProd] = useState('');
  const getSettings = async () => {
    try {

      const response = await getRequest(apiRoutes.get_settings); // Replace with your endpoint

      if (response.status==="success") {
    console.log("Response",response)
         dispatch(settingHandler(response));
          const Isprod = response?.data?.find(
    item => item.name === 'APP_ENV',
  );
  console.log('Isprod',Isprod?.value?.toLowerCase())
  setIsProd(Isprod)
      }
    } catch (error) {
      
    }
  };



useEffect(()=>{
  getSettings()
},[])
  const settingData = useSelector((state) => state.setting.value);
//  const IsProd = settingData?.data?.find(
//     item => item.name === 'ENV',
//   );



  const hideLayout = location.pathname === "/404"; // Check if the route is 404
  // Render a loader while the authentication status is being checked
  if (loading || !isProd) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div><Loader/></div> {/* You can replace this with a spinner */}
      </div>
    );
  }

  return (
    <>
{  
  isProd?.value?.toLowerCase()==='production'?
  <div>
         {/* {!hideLayout && (
  <div className={`md:h-[135px]  h-[90px] ${location.pathname === "/" ? "absolute" : ""}`}>

        <Header />
      </div>)} */}
      <div className="h-full w-full bg-NewbodyColor">
  <Routes>
      <Route path="*" element={<ComingSoon />}

      
      />
       <Route
      path="/terms-condition"
      element={
        <>
          <Header />
          <div className="pt-24 font-cairo">
          <TermsCondition />
          </div>
          <Footer />
        </>
      }
    />
          {/* <Route path="/terms-condition" element={<TermsCondition />} /> */}
      <Route path="/privacy-policy" element={
       <>
          <Header />
          <div className="pt-24 font-cairo">
          <Policy />
          </div>
          <Footer />
        </>
} />
      </Routes>
      </div>
 {/* {!hideLayout &&    <Footer />} */}
   </div>
   :
   
    <div className="justify-center w-full h-full font-cairo">
        {!hideLayout && (
  <div className={`md:h-[135px]  h-[90px] ${location.pathname === "/" ? "absolute" : ""}`}>
        <Header />
      </div>)}
      <div className="w-full">
        <div className="h-full w-full bg-NewbodyColor">
          <AppRoutes />
        </div>
        <div>
        {!hideLayout &&    <Footer />}
        </div>
      </div>
    </div>

     }
    </>
  );
};
